@if (loading()) {
  <div class="tw-flex tw-justify-center tw-py-8">
    <bit-icon
      name="bwi-spinner"
      class="bwi-spin tw-text-muted"
      [ariaLabel]="'loading' | i18n"
    ></bit-icon>
  </div>
} @else {
  @if (fingerprint(); as fingerprintPhrase) {
    <div class="bv-account-fingerprint-alert">
      <span class="bv-account-fingerprint-alert__icon" aria-hidden="true"></span>
      <p class="bv-account-fingerprint-alert__text">
        {{ "yourAccountsFingerprint" | i18n }}
        <span class="bv-account-fingerprint-alert__phrase">"{{ fingerprintPhrase }}"</span>
      </p>
    </div>
  }

  <div class="bv-account-profile">
    <div class="bv-account-profile__toolbar">
      <button type="button" class="bv-account-edit-btn" (click)="openEditName()">
        <span class="bv-account-edit-btn__icon" aria-hidden="true"></span>
        {{ "edit" | i18n }}
      </button>
    </div>
    <div class="bv-account-avatar-wrap">
      <dynamic-avatar [text]="avatarUser() | userName" [id]="userId()" size="2xl"> </dynamic-avatar>
      <button
        type="button"
        class="bv-account-avatar-add"
        appStopClick
        appStopProp
        (click)="openChangeAvatar()"
        [attr.aria-label]="'customize' | i18n"
      >
        <span class="bv-account-avatar-add__icon" aria-hidden="true">+</span>
      </button>
    </div>
    <h2 class="bv-account-name">{{ displayName() }}</h2>
  </div>

  <div class="bv-account-card">
    <div class="bv-account-card__header">
      <h3 class="bv-account-card__title">{{ "email" | i18n }}</h3>
      @if (canChangeEmail()) {
        <button type="button" class="bv-account-edit-btn" (click)="openEditEmail()">
          <span class="bv-account-edit-btn__icon" aria-hidden="true"></span>
          {{ "edit" | i18n }}
        </button>
      }
    </div>
    <div class="bv-account-card__body">
      <span class="bv-account-card__label">{{ "currentEmail" | i18n }}</span>
      <span class="bv-account-card__value">{{ email() }}</span>
    </div>
  </div>

  @if (managingOrganization(); as managingOrganization) {
    <p class="bv-account-owned-message">
      {{ "accountIsOwnedMessage" | i18n: managingOrganization?.name }}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://bitwarden.com/help/claimed-accounts"
      >
        <bit-icon name="bwi-question-circle"></bit-icon>
      </a>
    </p>
  }
}
